import { Link } from "@tanstack/react-router";
import { ArrowLeft, Compass } from "lucide-react";
import { Button } from "@/components/ui/button.tsx";

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="max-w-md space-y-4 text-center">
        <div className="mx-auto grid size-12 place-items-center rounded-full bg-muted text-muted-foreground">
          <Compass className="size-6" />
        </div>
        <div className="space-y-1">
          <h1 className="text-lg font-semibold tracking-tight">Page not found</h1>
          <p className="text-sm text-muted-foreground">The page you're looking for doesn't exist or has moved. Check the address, or head back to safety.</p>
        </div>
        <div className="flex justify-center gap-2">
          <Button variant="outline" onClick={() => window.history.back()}>
            <ArrowLeft /> Go back
          </Button>
          <Button asChild>
            <Link to="/">Go to home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
